import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ValidationService } from '../../Services/validation.service';
import { ActivityIndicatorService } from 'src/app/Services/activityIndicator.service';
import { MatSnackBar } from '@angular/material';
import { RestClientService } from 'src/app/Services/restClient.service';
import { RestResponseModel } from 'src/app/Models/RestResponseModel';
import { AppConfig } from 'src/app/constants';
import { DevicePinModel } from 'src/app/Models/DevicePinModel';
import { EncryptionService } from 'src/app/Services/encryption.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-unlock-account',
  templateUrl: './unlock-account.component.html',
  styleUrls: ['./unlock-account.component.scss']
})
export class UnlockAccountComponent implements OnInit {
  unlockAccountForm: FormGroup;
  unlockAccountControls: any;
  accountUnlockedSuccessfully = false;
  hidePin = false;

  private _payloadUnlockAccount: DevicePinModel;

  constructor(private validationService: ValidationService,
    private restClient: RestClientService,
    private encrypt: EncryptionService,
    private activityIndicator: ActivityIndicatorService,
    private _snackBar: MatSnackBar,
    private translate: TranslateService) {
    this._payloadUnlockAccount = new DevicePinModel();
  }

  ngOnInit() {
    this.unlockAccountForm = new FormGroup({
      Username: new FormControl('', Validators.required),
      Pin: new FormControl('', Validators.required),
    });

    this.unlockAccountControls = this.unlockAccountForm.controls;
  }

  unlockAccount() {
    if (this.unlockAccountForm.invalid) {
      return;
    }
    this.activityIndicator.ShowLoading(true);

    this._payloadUnlockAccount = this.unlockAccountForm.value as DevicePinModel;
    this._payloadUnlockAccount.Pin = this.encrypt.set(this._payloadUnlockAccount.Pin);
    this.restClient
      .Post<DevicePinModel, RestResponseModel>(AppConfig.UrlUnlock, this._payloadUnlockAccount)
      .subscribe(
        success => {
          this.accountUnlockedSuccessfully = true;
          this.activityIndicator.ShowLoading(false);
        },
        error => {
          const message = this.translate.get('errorMessage'.concat(error.errorMessage.toString()));
          message.subscribe((response) => {
            this._snackBar.open(response, 'Error', { duration: 5000 });
          });
          this.activityIndicator.ShowLoading(false);
        }
      );
  }

}
